import { useLocation } from 'react-router'

import { useMatchesPath } from '@/hooks/useMatchesPath'
import { PDF_ROUTES, ROUTES } from '@/lib/routes'

export function useIsPdf() {
  const location = useLocation()

  return (
    useMatchesPath(PDF_ROUTES) &&
    location.pathname !== ROUTES.compassPdfReportPreview()
  )
}
